// extracted by mini-css-extract-plugin
export default {"lopphu":"Loading_lopphu__rHxiz","dot_loading":"Loading_dot_loading__gM72M","jump":"Loading_jump__X2Grc"};